'use es6';

import { Record } from 'immutable';
export default new Record({
  id: null,
  adNetwork: null,
  accountId: null,
  name: null,
  installed: null,
  ownerAdAccountId: null,
  accessible: true,
  sendConversionEvents: null,
  facebookPixelEventFields: [],
  fbeinstalled: false,
  sendAllEventsConsent: null
});